import { useLocaleChoice, useLocales } from "@/lib/useLocales";
import { LanguagesCard } from "@/screens/translations/LanguagesCard";
import { StringsEditor } from "@/screens/translations/StringsEditor";
import { Notice } from "@/components/ui/feedback";
import { PageHeader } from "@/components/ui/page-header";

/**
 * The languages the shop speaks, and the words it says in each.
 *
 * TWO THINGS ON ONE SCREEN, and now in two files, because they are separate
 * everywhere else too: the worker keeps them on two routes, and one of the two
 * can take every page of the site away from every visitor while the other only
 * changes what those pages say. `translations/LanguagesCard.tsx` and
 * `translations/StringsEditor.tsx` each carry the rules of their own half.
 *
 * What is left here is the composition, and one decision that belongs to it:
 * the list is loaded ONCE and handed to both. The editor's reference column
 * needs the same set of languages the switch above it is toggling, and two
 * reads of it would let the two disagree for as long as one request takes.
 */
export function TranslationsScreen() {
  const { locales, loading, error, reload } = useLocales();
  const [selected, setSelected] = useLocaleChoice(locales);

  return (
    <div className="space-y-4">
      <PageHeader
        title="Translations"
        description="The languages this shop offers, and every string it renders."
      />
      {error && <Notice tone="error">{error}</Notice>}

      <LanguagesCard locales={locales} loading={loading} onChanged={reload} />

      {selected && (
        <StringsEditor
          locales={locales}
          locale={selected}
          onLocale={setSelected}
          onSaved={reload}
        />
      )}
    </div>
  );
}
